import React from 'react'
import './index.css'
import Routes from './application/routes'

import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import { PersistGate } from 'redux-persist/integration/react'
import configureStore from './application/redux/store'
import { Provider } from 'react-redux'

const { store, persistor } = configureStore();

function App() {
  return (
    <Provider store={store}>
      
      <PersistGate loading={null} persistor={persistor}>
        <Routes />

        <ToastContainer
          position="top-right"
          autoClose={3000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          pauseOnHover
        />
      </PersistGate>

    </Provider>
  );
}

export default App;
